/** Configuration Constants - Single Source of Truth */

// Theme colors
export const COLORS = [
  'violet', 'blue', 'pink', 'teal', 'orange', 'green', 'yellow', 'grape'
];

// API configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3004/api';
export const SOCKET_URL = process.env.REACT_APP_API_BASE || 'http://localhost:4000';

// SLA and timing
export const SLA_THRESHOLD_MINUTES = 30;

// Emoji library (canned responses)
export const EMOJIS = [
  '😊', '😂', '❤️', '👍', '🙏', '😍', '🎉', '🔥',
  '😢', '💯', '👏', '🤔', '😎', '🫡', '💬'
];

// Canned responses
export const CANNED_RESPONSES = [
  {
    category: 'Greetings',
    color: 'blue',
    items: [
      { label: 'Welcome', text: 'Hello! Welcome to our support. How can I assist you today?' },
      { label: 'Good morning', text: 'Good morning! Thanks for reaching out. How can I help?' },
      { label: 'Returning user', text: 'Welcome back! Great to hear from you again. How can I help?' },
    ]
  },
  {
    category: 'Common Queries',
    color: 'violet',
    items: [
      { label: 'Ask order #', text: 'Could you please provide your order number so I can look into this?' },
      { label: 'Ask email', text: 'May I have the email address associated with your account?' },
      { label: 'Checking now', text: 'Let me check that for you right away — please give me a moment.' },
      { label: 'Processing', text: 'I have submitted your request. It will be processed within 3–5 business days.' },
    ]
  },
  {
    category: 'Closings',
    color: 'violet',
    items: [
      { label: 'Resolved', text: 'I am glad we could resolve this for you. Is there anything else I can help with?' },
      { label: 'Thank you', text: 'Thank you for contacting support. Have a wonderful day!' },
      { label: 'Follow up', text: 'Feel free to reach out anytime. We are always here to help!' },
    ]
  },
  {
    category: 'Handoffs',
    color: 'orange',
    items: [
      { label: 'Escalating', text: 'Let me escalate this to our specialist team for you.' },
      { label: 'Transferred', text: 'I am transferring you to a specialist who can better assist you.' },
    ]
  }
];

// Role-based access control
export const ROLE_CONFIG = {
  super_admin: {
    label: 'Super Admin',
    panelTitle: 'Super Admin Panel',
    color: 'violet',
    gradient: { from: '#9381ff', to: '#b8b8ff' },
    storagePrefix: 'superadmin',
    tabs: ['dashboard', 'users', 'clients', 'transactions', 'captive_portal'],
    canCreateUser: true,
    canEditUser: true,
    canDeleteUser: true,
    canCreateClient: true,
    canEditClient: true,
    canDeleteClient: true,
    allowedRoles: ['super_admin'],
    visibleUserRoles: ['super_admin', 'manager', 'supervisor', 'helpdesk_agent'],
    roleFilterOptions: [
      { value: 'all', label: 'All Roles' },
      { value: 'helpdesk_agent', label: 'Helpdesk Agent' },
      { value: 'manager', label: 'Manager' },
      { value: 'supervisor', label: 'Supervisor' },
      { value: 'super_admin', label: 'Super Admin' },
    ],
  },
  manager: {
    label: 'Manager',
    panelTitle: 'Manager Panel',
    color: 'blue',
    gradient: { from: 'blue', to: 'cyan' },
    storagePrefix: 'manager',
    tabs: ['dashboard', 'users', 'transactions', 'captive_portal', 'queue'],
    canCreateUser: true,
    canEditUser: true,
    canDeleteUser: false,
    canCreateClient: false,
    canEditClient: false,
    canDeleteClient: false,
    allowedRoles: ['manager'],
    visibleUserRoles: ['helpdesk_agent'],
    roleFilterOptions: [
      { value: 'all', label: 'All' },
      { value: 'helpdesk_agent', label: 'Helpdesk Agent' },
    ],
  },
  supervisor: {
    label: 'Supervisor',
    panelTitle: 'Supervisor Panel',
    color: 'cyan',
    gradient: { from: 'cyan', to: '#9381ff' },
    storagePrefix: 'supervisor',
    tabs: ['dashboard', 'users', 'transactions', 'captive_portal', 'queue'],
    canCreateUser: true,
    canEditUser: true,
    canDeleteUser: false,
    canCreateClient: false,
    canEditClient: false,
    canDeleteClient: false,
    allowedRoles: ['supervisor'],
    visibleUserRoles: ['manager', 'helpdesk_agent'],
    roleFilterOptions: [
      { value: 'all', label: 'All' },
      { value: 'helpdesk_agent', label: 'Helpdesk Agent' },
      { value: 'manager', label: 'Manager' },
    ],
  },
};

// Chat session states
export const CHAT_STATES = {
  IDLE: 'idle',
  INFO: 'info',
  QUEUED: 'queued',
  CHATTING: 'chatting',
  CLOSED: 'closed',
  REJECTED: 'rejected'
};

// Call types
export const CALL_TYPES = {
  AUDIO: 'audio',
  VIDEO: 'video'
};

// Storage keys
export const STORAGE_KEYS = {
  TOKEN: 'Token',
  USER: 'User',
  CHAT_ROOM_ID: 'chat_roomId',
  SETTINGS: 'settings'
};
